<template>
    <div>
        <h1 style="padding: 0 1rem; padding-top: 15px; font-weight: 300;">Inbox</h1>
        <div class="menu-container">
            <div style="padding-left: 1rem; /*border-bottom: 1px solid #eee;*/ padding-bottom: 1rem; margin-bottom: 1rem;">
              <ui-icon-button tooltip="New Message" style="vertical-align: middle;" icon="send" type="secondary" @click="$refs.newMessageModal.open()"></ui-icon-button>
              <ui-icon-button tooltip="Log Conversation" style="vertical-align: middle;" icon="chat_bubble_outline" type="secondary" @click="$refs.logConversationModal.open()"></ui-icon-button>
            </div>
            <ul class="options-menu">
                <template v-for="item in items">
                <li v-if="item.type && item.type === 'separator'" class="separator">
                    <hr style="margin: 0;">
                </li>
                <li v-else :class="classesFor(item)" @click="itemClicked(item)">
                    <span class="icon-holder">
                        <span
                            v-if="item.icon === 'dot'"
                            class="dot"
                            :style="{ background: item.colour }"
                        ></span>
                        <span v-else class="material-icons-outlined">{{ item.icon }}</span>
                    </span>
                    <span class="item-label">{{ item.label }}</span>
                    <span class="item-count" v-if="item.count > 0">{{ item.count }}</span>
                </li>
                </template>
            </ul>
        </div>

        <new-message-modal ref="newMessageModal" />
        <log-conversation-modal ref="logConversationModal" />
    </div>
</template>

<script>
    import NewMessageModal from "./ComposeMessageModal";
    import LogConversationModal from "./LogConversationModal";
    import {autoRespondEnabled} from "../../../ts/Inbox/CruiseControl";

    export default {
        components: {LogConversationModal, NewMessageModal },
        methods: {
            itemClicked(item) {
                if (item.route) {
                    this.$router.push(item.route)
                }
            },
            classesFor(item) {
                let classes = []

                if (this.$route.path.indexOf(item.navRouteMatch) > -1) {
                    classes.push('active')
                }

                return classes
            }
        },
        computed: {
            items() {
                const items = [
                    {
                    type: 'separator'
                    },{
                        label: 'Mine',
                        icon: 'pan_tool',
                        route: '/inbox/mine',
                        navRouteMatch: '/inbox/mine',
                        count: this.$store.getters['user/badges/inboxCountMine']
                    },{
                        label: 'Waiting',
                        icon: 'timer_outline',
                        route: '/inbox/waiting',
                        navRouteMatch: '/inbox/waiting',
                        count: this.$store.getters['user/badges/inboxCountWaiting']
                    }
                ]

                if (autoRespondEnabled()) {
                    items.push({
                        label: 'AI',
                        icon: 'auto_awesome',
                        route: '/inbox/ai',
                        navRouteMatch: '/inbox/ai',
                        count: this.$store.getters['user/badges/inboxCountAi']
                    })
                }

                items.push({
                    label: 'Follow Up',
                    icon: 'flag',
                    route: '/inbox/follow-up',
                    navRouteMatch: '/inbox/follow-up',
                    count: this.$store.getters['user/badges/inboxCountFollowUp']
                },{
                    label: 'Closed',
                    icon: 'mark_email_read',
                    route: '/inbox/closed',
                    navRouteMatch: '/inbox/closed'
                },{
                    label: 'Junk',
                    icon: 'do_not_disturb',
                    route: '/inbox/junk',
                    navRouteMatch: '/inbox/junk'
                },{
                    label: 'Bin',
                    icon: 'delete',
                    route: '/inbox/bin',
                    navRouteMatch: '/inbox/bin'
                })

                /*let messageBoxes = this.$store.getters['inbox/messageBoxes/all'];

                for (let i in messageBoxes) {
                    items.push({
                        label: messageBoxes[i].name,
                        icon: 'dot',
                        colour: '#ccc', //messageBoxes[i].colour
                        route: '/inbox/' + messageBoxes[i].id + '/unassigned',
                        navRouteMatch: '/inbox/' + messageBoxes[i].id,
                        count: this.$store.getters['user/badges/inboxCountMessageBox'](messageBoxes[i].id)
                    })
                }*/

                /*items.push({
                    label: 'Overdue',
                    icon: 'alarm',
                    route: '/inbox/overdue/open',
                    navRouteMatch: '/inbox/overdue',
                    count: this.$store.getters['user/badges/inboxCountOverdue']
                },{
                    type: 'separator'
                }/*,{
                    label: 'Reminders',
                    icon: 'notifications_active',
                    route: '/inbox/reminders'
                })*/

                //return items

                return items
            }
        }
    }
</script>

<style lang="scss" scoped>

  .menu-container {
    /*border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;*/
    margin: 1rem 0 1rem;
  }

  .item-count {
      float: right;
      padding: .25rem .5rem;
      //background: rgba(255,255,255, .5);
      background: crimson;
      color: white;
      line-height: normal;
      border-radius: 3px;
      font-size: .9rem;
      font-weight: bold;
  }

  .item-label {
      max-width: 102px;
      text-overflow: ellipsis;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
  }

  ul.options-menu {
    list-style: none;
    padding: 0;
    margin: 1rem 0;
    li {
      padding: .5rem 1rem;
      margin-bottom: 5px;
      &.active, &:not(.separator):hover {
        background: rgba(0,0,0,0.05);
        border-radius: 1px;
        cursor: pointer;
      }
      &.active {
        font-weight: bold;
      }
    }
    span { vertical-align: middle; }
    .icon-holder {
      display: inline-block;
      width: 25px;
      margin-right: 10px;
      text-align: center;
      line-height: normal;
      .dot {
        display: inline-block; border-radius: 15px; width: 15px; height: 15px;
      }
    }
  }
</style>